var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { SideNavItem, SideNavItemContext } from './SideNavItem';
import { SideNavGroup } from './SideNavGroup';
import { Headline } from '../Headline';
import { CollapsibleList } from '../../internal/CollapsibleList';
import { useArrowNav } from '../../hooks/useArrowNav';
export const SideNav = (_a) => {
    var { children, className, title, 'data-anvil-component': dataAnvilComponent } = _a, rest = __rest(_a, ["children", "className", "title", 'data-anvil-component']);
    const sideNavItemContext = React.useContext(SideNavItemContext);
    const SideNavClasses = classnames('SideNav', className);
    const containerRef = useArrowNav({
        loop: false,
        onKeyDown: handleArrowKeys,
    });
    // Nested SideNav
    if (sideNavItemContext)
        return (React.createElement(CollapsibleList, Object.assign({ className: SideNavClasses, el: "div" }, rest),
            React.createElement("menu", { className: "SideNav__list" }, children)));
    return (React.createElement("div", Object.assign({ className: SideNavClasses, "data-anvil-component": "SideNav", ref: containerRef }, rest),
        title !== undefined && (React.createElement(Headline, { el: "div", className: "SideNav__title", size: "small" }, title)),
        React.createElement("menu", { className: "SideNav__list" }, children)));
};
SideNav.Item = SideNavItem;
SideNav.Group = SideNavGroup;
const handleArrowKeys = (e, data) => {
    var _a, _b, _c, _d, _e, _f;
    const itemClasses = (_b = (_a = data === null || data === void 0 ? void 0 : data.active) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.classList;
    const isExpanded = itemClasses === null || itemClasses === void 0 ? void 0 : itemClasses.contains('CollapsibleListItem--expanded');
    const expandedItem = (_f = (_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.active) === null || _c === void 0 ? void 0 : _c.closest) === null || _d === void 0 ? void 0 : _d.call(_c, '.CollapsibleListItem--expanded')) === null || _e === void 0 ? void 0 : _e.querySelector) === null || _f === void 0 ? void 0 : _f.call(_e, '.SideNavItem__button--expanded');
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight')
        data.disableOnce(); // Prevent focus move on left-right
    if (isExpanded && e.key === 'ArrowRight')
        data.next.focus(); // Move focus to first focusable
    if (expandedItem && e.key === 'ArrowLeft')
        expandedItem === null || expandedItem === void 0 ? void 0 : expandedItem.focus(); // Move focus to closest expanded
};
//# sourceMappingURL=SideNav.js.map